Object.defineProperty(window, 'COMMUNITY_URL_TEST', {
  get: function () {
    return localStorage.getItem('COMMUNITY_URL_TEST') || '';
  },
});
declare global {
  interface Window {
    COMMUNITY_URL_TEST: string;
  }
}
export const COMMUNITY_URL_TEST = window.COMMUNITY_URL_TEST;
